export default __webpack_public_path__ + "static/media/sendy_logo.f2d96f5a.png";